<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>login</ion-title>
  </ion-toolbar>
</ion-header>

<!-- <ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">login</ion-title>
    </ion-toolbar>
  </ion-header>
</ion-content> -->




<!-- login.page.html -->
<ion-content>
  <div class="login-wrapper">
    <div class="login-container">
        
      <ion-input style="color: black; border-bottom: 1px solid lightgrey" type="text" [(ngModel)]="username" placeholder="Username"></ion-input>
      
      
        <ion-input style="color: black; border-bottom: 1px solid lightgrey" type="password" [(ngModel)]="password" placeholder="Password"></ion-input>
      
      

        <div class="error-message" [class.hidden]="areCredentialsValid">
          Username and password are invalid
        </div>

        <ion-button expand="full" (click)="login()">Login</ion-button>
      
    </div>
  </div>

  <ion-row style="margin-top: 20px; text-align: center;">
    <ion-col>
        <span class="link" (click)="navigateToRegistration()" style="color: black; cursor: pointer; font-size: 13px;">
          Don't have an account? Register Here
        </span>
    </ion-col>
</ion-row>
</ion-content>


